// ANGULAR
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

// OTHER
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { forkJoin, Observable } from 'rxjs';

// ACTIUM
import { ActionType } from '../../../models/action-type';
import { ActionTypeDataService } from '../../../services/action-type-data.service';

import { UserGroup } from '../../../models/usergroup';
import { UserDataService } from '../../../services/user-data.service';

import { GroupRole } from '../../../models/grouprole';

@Component({
  selector: 'app-create-action-type',
  templateUrl: './create-action-type.component.html',
  styleUrls: ['./create-action-type.component.scss']
})
export class CreateActionTypeComponent implements OnInit {

  public dynamicGroupHeader: string = '';
  public mode: string = '';
  public actiontype: ActionType = null;
  public accordianActiveState: boolean[] = [true, false, false];
  public groupInformationForm: FormGroup = null;

  // USER ASSOC PICKLIST REQUIRED ARRAYS

  public allUserGroupByGroup: UserGroup[] = [];
  public finalUserGroupsToUpdate: UserGroup[] = [];

  // ROLE ASSOC PICKLIST REQUIRED ARRAYS

  public allGroupRolesByGroup: GroupRole[];
  public finalGroupRolesToUpdate: GroupRole[];

  constructor(public ref: DynamicDialogRef,
              private formBuilder: FormBuilder,
              private config: DynamicDialogConfig,
              private actionTypeService: ActionTypeDataService,
              private userService: UserDataService) {
    this.groupInformationForm = formBuilder.group({
      actionName: new FormControl('', [Validators.required]),
      a20: new FormControl(false)
    });
  }   

  ngOnInit(): void {

    this.actiontype = this.config.data.actiontype;

    switch (this.actiontype) {
      case null:
      case undefined:

        this.mode = 'create';
        break;
      default:

        this.mode = 'edit';
        this.dynamicGroupHeader = ': ' + this.actiontype.actionName;
        this.populateGroupInformationForm(this.actiontype);
        break;
    }
  }

  // ***** GROUP FORM RELATED FUNCTIONS *****

  populateGroupInformationForm(actiontype: ActionType): void {
    this.groupInformationForm.patchValue({
      actionName: actiontype.actionName,
      a20: actiontype.a20
    });
  }

  submitGroupInformationForm(): void {
    if (this.mode === 'create') { this.actionTypeService.addNewActionType(this.handleCreateGroupRequest())
      .subscribe((createdActiontype: ActionType) => {
        this.actiontype = createdActiontype;
        this.ref.close();
      }); }
    if (this.mode === 'edit') {
      this.actionTypeService.updateActionType(this.handleUpdateGroupRequest())
        .subscribe((updatedGroup: ActionType) => {
          this.actiontype = updatedGroup;
          this.ref.close();
      }); }
  }

  handleUpdateGroupRequest(): ActionType {
    const formData = this.groupInformationForm.value;
    const updateGroupRequest: ActionType = {
      actionName: formData.actionName,
      id: this.actiontype.id,
      a20: formData.a20
    };
    return updateGroupRequest;
  }

  handleCreateGroupRequest(): ActionType {
    const formData = this.groupInformationForm.value;
    const createdGroupRequest: ActionType = {
      actionName: formData.actionName,
      a20: formData.a20
    };
    return createdGroupRequest;
  }

  deleteActionType(): void {
    this.actionTypeService.deleteActionType(this.actiontype.id).subscribe((res: boolean) => {
      this.ref.close();
    });
  }

  // ***** END OF GROUP FORM RELATED FUNCTIONS *****


}
